export default "__VITE_ASSET__CuPauV1G__"